export default () => ({
  page: {
    display: 'flex',
    flexDirection: 'column',

    minHeight: '100vh'
  }
})



// WEBPACK FOOTER //
// ./components/page/styles.js